import React, {useState} from "react";
import EditButton from "../../../components/button/EditButton";
import ModalForm from "../../../components/form/ModalForm";
import fields from "./PartEditionFormConfig";
import {Actions} from "../../../../client/Actions";
import { useTranslation } from 'react-i18next';

const PartEdition = ({part, setLoader, setReload, reload}) => {

    const {t} = useTranslation();
    const [open, setOpen] = useState(false)

    const save = (data, onSaved) => {
        setLoader(true)
        Actions.put("part/" + part.id, data, onSaved)


    }


    return (
        <>
            {part &&
                <EditButton onClick={() => setOpen(true)}/>
            }
            {open &&
                <ModalForm
                    open={open}
                    setOpen={setOpen}
                    setLoader={setLoader}
                    size={"md"}
                    initialData={part}
                    title={t("parameters.edition")}
                    fields={fields(t)}
                    customSave={save}
                    onFinish={() => setReload(!reload)}
                />
            }


        </>
    );
};


export default PartEdition;